
export enum DisputeAreaCd {
	EASTERN = 'Eastern',
	MIDWESTERN_CENTRAL = 'MidwesternCentral',
	SOUTHERN = 'Southern',
	WESTERN = 'Western'}

